module.exports = __webpack_public_path__ + "static/media/C34.PNG.6270cd7d.png";